module.exports = __webpack_public_path__ + "media/images/bg-ethereum-c0cbe137e92672855174038b916cc565.jpg";